// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {Breakpoint} from '@travel-frontend/themes';
import type {SetBreakpoint} from 'redux/uiState/layout/base/actions';
import type {BaseState} from 'redux/uiState/layout/base/BaseState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {SET_BREAKPOINT} from 'redux/uiState/layout/base/actions';
import {baseState} from 'redux/uiState/layout/LayoutState';

const initialState: Partial<BaseState> = {};

const actionCreators: ActionHandlers<BaseState> = {
  [PURE(SET_BREAKPOINT)]: (state: BaseState, action: SetBreakpoint) => ({
    ...state,
    breakpoint: action.breakpoint,
  }),
};

export const baseReducer: Reducer<BaseState> = // $FlowIgnore
  createReducerUsingActionHandlers<BaseState>(initialState, actionCreators);

export const isBreakpointSet: Selector<boolean> = createSelector(
  baseState,
  (state: BaseState) => state.breakpoint !== undefined
);

export const getCurrentBreakpoint: Selector<Breakpoint> = createSelector(
  baseState,
  (state: BaseState) => state.breakpoint
);
